import React, { useState, useEffect } from 'react';
import Modal from '../../../components/common/Modal'; // Adjust path as needed
import { Chat } from '../types'; // Import Chat type
import { Avatar } from '@chatscope/chat-ui-kit-react';
import { PLACEHOLDER_AVATAR_SVG } from '../types';

interface ForwardMessageModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirmForward: (targetChatId: string) => void;
    chats: Chat[];
    currentChatId: string;
}

const ForwardMessageModal: React.FC<ForwardMessageModalProps> = ({
    isOpen,
    onClose,
    onConfirmForward,
    chats,
    currentChatId,
}) => {
    const [selectedChatId, setSelectedChatId] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState('');

    // Reset selection when modal opens or closes
    useEffect(() => {
        if (isOpen) {
            setSelectedChatId(null);
            setSearchTerm(''); // Reset search on open
        }
    }, [isOpen]);

    const handleConfirm = () => {
        if (selectedChatId) {
            onConfirmForward(selectedChatId);
        }
    };

    // Filter chats based on search term and exclude the current chat
    const filteredChats = chats.filter(chat =>
        chat.id !== currentChatId &&
        chat.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Переслать сообщение">
            <div className="p-4">
                {/* Search Input */}
                <input
                    type="text"
                    placeholder="Поиск чата..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full p-2 mb-4 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                />

                {/* Chat List */}
                <div className="max-h-60 overflow-y-auto border border-gray-200 dark:border-gray-600 rounded-md">
                    {filteredChats.length > 0 ? (
                        filteredChats.map((chat) => (
                            <div
                                key={chat.id}
                                onClick={() => setSelectedChatId(chat.id)}
                                className={`flex items-center p-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-400 ${selectedChatId === chat.id ? 'bg-blue-100 dark:bg-blue-900' : ''}`}
                            >
                                <Avatar src={chat.profilePicUrl || PLACEHOLDER_AVATAR_SVG} name={chat.name} size="sm" className="mr-3" />
                                <span className="text-sm font-medium text-gray-800 dark:text-gray-600">{chat.name}</span>
                            </div>
                        ))
                    ) : (
                        <p className="p-3 text-center text-gray-500 dark:text-gray-400">Нет подходящих чатов.</p>
                    )}
                </div>

                {/* Action Buttons */}
                <div className="mt-6 flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
                    >
                        Отмена
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={!selectedChatId}
                        className={`px-4 py-2 rounded-md focus:outline-none ${!selectedChatId
                                ? 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400'
                                : 'bg-blue-500 text-white hover:bg-blue-600'
                            }`}
                    >
                        Переслать
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ForwardMessageModal;
